import { useState } from "react"
import { useTranslation } from "react-i18next"
import { useAuth } from "../../hooks/useAuth"
import { useWelcomeStore } from "../../stores/welcomeStore"

interface IProps {}

const ResetPasswordRequest = (props: IProps) => {
  const {
    requestPasswordReset,
    resetPasswordRequested,
    resetRequestPasswordReset,
    loading
  } = useAuth()
  const { t } = useTranslation()
  const { study } = useWelcomeStore()
  const [inputs, setInputs] = useState({
    email: ""
  })

  const resetPasswordRequestForm = (
    event: React.FormEvent<HTMLFormElement>
  ) => {
    event.preventDefault()
    const email = inputs["email"]
    requestPasswordReset(email)
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const name = e?.target?.name
    const value = e?.target?.value
    setInputs((values) => ({ ...values, [name]: value }))
  }

  return (
    <div className="flex items-center justify-center bg-cortexx-100 w-screen h-screen">
      <div className="bg-cortexx-50 w-full md:w-2/3 h-screen">
        <div className="flex items-center justify-center my-4">
          <div className="bg-cortexx-50">
            <img
              src={
                study
                  ? study?.administrative_information.logo_url
                  : "/images/vector-logo.svg"
              }
              style={{ height: "30px" }}
              alt="RP Logo"
              loading="lazy"
            />
          </div>
        </div>
        <div className="flex h-full w-full flex-col mt-24">
          <div className="flex items-center justify-center w-full my-4">
            <div className="flex-row w-full md:w-1/2 mx-6">
              <h1 className="font-semibold text-2xl text-cortexx-900 text-center">
                {t("auth.reset_password")}
              </h1>
              {!resetPasswordRequested ? (
                <h2 className="font-normal text-l text-cortexx-900 text-center mt-4">
                  {t("auth.reset_password_description")}
                </h2>
              ) : (
                <>
                  <h2 className="font-normal text-l text-cortexx-900 text-center mt-4">
                    {t("auth.reset_password_sent")}
                  </h2>
                  <h2 className="font-normal text-l text-cortexx-900 text-center mt-4">
                    {t("auth.reset_password_not_received")}
                  </h2>
                </>
              )}
            </div>
          </div>
          {!resetPasswordRequested ? (
            <form
              className="flex flex-col items-center m-6"
              onSubmit={resetPasswordRequestForm}
            >
              <div className="flex flex-col items-left justify-center mb-4">
                <>
                  <h2 className="font-semibold text-lg text-cortexx-550">
                    email
                  </h2>
                  <input
                    className="border-2 border-slate-300 rounded-xl w-72 py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none"
                    name="email"
                    type="email"
                    placeholder="email"
                    onChange={handleChange}
                  />
                </>
                {!loading ? (
                  <div className="flex justify-end items-end mt-4">
                    <button
                      className="bg-cortexx-550 hover:opacity-60 rounded-lg py-2 px-4 text-cortexx-50 font-semibold"
                      type="submit"
                    >
                      <p>{t("auth.reset")}</p>
                    </button>
                  </div>
                ) : (
                  <div className="flex justify-end items-end mt-4">
                    <button
                      className="bg-cortexx-100 hover:opacity-60 rounded-lg py-2 px-4 text-cortexx-500 font-semibold"
                      disabled={true}
                    >
                      <div className="flex flex-row justify-center items-center">
                        <p>{t("auth.sending")}</p>
                        <div className="ml-2">
                          <img
                            src="/images/fade-stagger-circles.svg"
                            style={{ height: "20px" }}
                            alt="close"
                            loading="lazy"
                          />
                        </div>
                      </div>
                    </button>
                  </div>
                )}
              </div>
            </form>
          ) : (
            <div className="flex flex-col items-center justify-end m-6">
              <button
                className="bg-cortexx-550 hover:opacity-60 rounded-lg py-2 px-4 text-cortexx-50 font-semibold"
                onClick={resetRequestPasswordReset}
              >
                <p>Réessayer</p>
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default ResetPasswordRequest
